import { ReactNode, useMemo } from 'react'

interface DeviceSplitProps {
  isMobile: boolean
  common?: ReactNode
  mobile?: ReactNode
  desktop?: ReactNode
}

const DeviceSplit = ({ isMobile, common, mobile, desktop }: DeviceSplitProps) => {
  const DeviceComponent = useMemo(() => {
    if (common) return common

    return isMobile ? mobile : desktop
  }, [isMobile, common, mobile, desktop])

  if (DeviceComponent) {
    return <>{DeviceComponent}</>
  } else {
    return <></>
  }
}

export default DeviceSplit
